const TransformTitle = (key) => {
	const titles = {
		'ad' : 'Algemeen Dagblad',
		'trouw' : 'Trouw',
		'parool' : 'Parool',
		'volkskrant' : 'Volkskrant',
		'bd' : 'Brabants Dagblad',
		'bndestem' : 'BN DeStem',
		'tubantia' : 'Tubantia',
		'pzc' : 'PZC',
		'ed' : 'Eindhovens Dagblad',
		'destentor' : 'de Stentor',
		'degelderlander' : 'de Gelderlander'
	};

	return titles[key];
}

export default TransformTitle;


	
